const tokenKey = "token"
const ctaKey = "hideAuthCTA"

/**
 * Universal token getter:
 * - Server → reads from cookies()
 * - Client → reads from localStorage
 */
export async function getToken(): Promise<string | null> {
  if (typeof window === "undefined") {
    // Server: dynamic import to keep the file universal
    const { cookies } = await import("next/headers")
    const cookieStore = await cookies()
    const token = cookieStore.get(tokenKey)?.value ?? null
    return token
  }

  // Client
  const token = localStorage.getItem(tokenKey)
  return token
}

/**
 * Client-only token setter
 */
export function setToken(token: string) {
  if (typeof window === "undefined") return
  localStorage.setItem(tokenKey, token)
}

/**
 * Client-only token clear
 */
export function clearToken() {
  if (typeof window === "undefined") return
  localStorage.removeItem(tokenKey)
}

/**
 * Get Hide CTA Flag
 */
export function getHideCTA(): boolean | null {
  if (typeof window === "undefined") return null
  return localStorage.getItem(ctaKey) === "true"
}

/**
 * Set Hide CTA Flag
 */
export function setHideCTA() {
  if (typeof window === "undefined") return
  localStorage.setItem(ctaKey, "true")
}

/**
 * Reset Hide CTA Flag
 */
export function resetHideCTA() {
  if (typeof window === "undefined") return
  localStorage.removeItem(ctaKey)
}
